import React, { useState, useEffect } from 'react';
import { Avatar, Spin } from 'antd';
import columns from "../../../columns/AccountHistory.js";
import TableWithSkeleton from '../../../components/global/table/TableWithSkeleton';
import { useParams } from 'react-router-dom';
import { GetTraderaccountByIdApi, GetTraderAccountTransactionApi } from '../../../api/request/client.js';
import moment from 'moment/moment.js';

export default function LiveAccountDetails() {

    const { loginId } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);
    const [trader, setTrader] = useState({});
    const [accountdetails, setAccountdetails] = useState([]);

    const getTraderaccountById = async () => {
        try {
            setIsLoading(true);
            const { data } = await GetTraderaccountByIdApi(loginId);
            if (data?.success) {
                setTrader(data?.data);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
        }
    }

    const getallaccountdetails = async () => {
        try {
            setIsLoadingHistory(true);
            const { data } = await GetTraderAccountTransactionApi(loginId);
            if (data?.success) {
                setAccountdetails(data?.data?.map(item => {
                    return {
                        ...item,
                        amount: item?.amount?.toFixed(2),
                        currentRate: item?.currentPrice?.toFixed(2),
                        openRate: item?.openPrice?.toFixed(2),
                        closeRate: item?.closePrice?.toFixed(2),
                        // profit: item?.profit?.toFixed(2),
                        // totalProfit: item?.totalProfit?.toFixed(3),
                        stopLoss: item?.stopLoss?.toFixed(3),
                        takeProfit: item?.takeProfit?.toFixed(3),
                        dateTime: item?.dateTime ? moment(item.dateTime).format('DD-MM-YYYY, hh:mm A') : '--',
                        openDateTime: item?.openDateTime ? moment(item?.openDateTime).format('DD-MM-YYYY, hh:mm A') : '--',
                        closeDateTime: item?.closeDateTime ? moment(item?.closeDateTime).format('DD-MM-YYYY, hh:mm A') : '--',
                    }
                }));
            }
            setIsLoadingHistory(false);
        } catch (error) {
            setIsLoadingHistory(false);
        }
    }

    useEffect(() => {
        getTraderaccountById();
        getallaccountdetails()
    }, []);

    const getInitials = (name) => {
        if (!name) {
            return;
        }
        const nameParts = name?.trim()?.split(' ');
        const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
        return initials.toUpperCase();
    };

    return (
        <div>
            <div className="border-2 border-light rounded-xl p-4 lg:p-6">
                {(isLoading) ? (
                    <div className="flex justify-center flex-col my-[12%]">
                        <Spin size="large" />
                        <p className="primary text-center mt-2">Loading...</p>
                    </div>
                ) : (
                    <div>
                        <div className="flex flex-wrap justify-between items-center gap-5">
                            <div className="flex items-center gap-3">
                                <Avatar size={50} className="uppercase bg-primary" src={trader?.profileImage}>{getInitials(trader?.fullName)}</Avatar>
                                <p className="font-bold text-lg capitalize">{trader?.fullName}</p>
                                {trader?.isIBUser == 'Yes' &&
                                    <div className="bg-primary-light rounded-md px-2"><p className="primary text-sm font-semibold">IB User</p></div>
                                }
                            </div>
                        </div>
                        <div className="w-full grid md:grid-cols-2 xl:grid-cols-4 gap-5 mt-5">
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Full Name</p>
                                <p className='primary text-lg font-semibold mt-2'>{trader?.fullName}</p>
                            </div>
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Email</p>
                                <p className='primary text-lg font-semibold mt-2'>{trader?.email}</p>
                            </div>
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Country</p>
                                <p className='primary text-lg font-semibold mt-2'>{trader?.country}</p>
                            </div>
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Account Number</p>
                                <p className='primary text-lg font-semibold mt-2'>{loginId}</p>
                            </div>
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Group Name</p>
                                <p className='primary text-lg font-semibold mt-2'>{trader?.groupName}</p>
                            </div>
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Balance</p>
                                <p className='primary text-lg font-semibold mt-2'>$ {trader?.balance || 0}</p>
                            </div>
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Leverage</p>
                                <p className='primary text-lg font-semibold mt-2'>{trader?.leverage}</p>
                            </div>
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Profit</p>
                                <p className='primary text-lg font-semibold mt-2'>$ {trader?.netProfit || 0}</p>
                            </div>
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Credit</p>
                                <p className='primary text-lg font-semibold mt-2'>$ {trader?.credit || 0}</p>
                            </div>
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Margin</p>
                                <p className='primary text-lg font-semibold mt-2'>$ {trader?.accountBalance?.margin || 0}</p>
                            </div>
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Free Margin</p>
                                <p className='primary text-lg font-semibold mt-2'>$ {trader?.freeMargin || 0}</p>
                            </div>
                            <div>
                                <p className='text-[#1E232CC7] text-lg'>Equity</p>
                                <p className='primary text-lg font-semibold mt-2'>$ {trader?.equity || 0}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full mt-5">
                <div className="px-4 lg:px-6">
                    <p className="text-[#2F2B3D] text-xl font-semibold">History of {loginId}</p>
                </div>
                <div className="my-6">
                    <TableWithSkeleton columns={columns} data={accountdetails} loading={isLoadingHistory} />
                    {/* <Pagination total={100} pageSize={pageSize} setPageSize={setPageSize} /> */}
                </div>
            </div>
        </div>
    )
}
